import React from "react";
import useFetchWlNameLogoComName from "../../hooks/whiteLabel/useFetchWlNameLogoComName";
import { isCustomResumeDomain } from "../../utils/functions";
import CarrerClawLogo from "../../assets/image/svg/carrer-claw.svg";
import CarrerClawMark from "../../assets/image/svg/carrer-claw-mark.svg";
import CustomResumeLogo from "../../assets/image/Custom-resume-logo.png";

const HeaderLogo = () => {
  const { wlCompanyLogo } = useFetchWlNameLogoComName();

  const onImageError = (e) => {
    e.target.src = CarrerClawLogo;
  };

  const getSrc = () => {
    if (isCustomResumeDomain()) {
      return CustomResumeLogo;
    } else if (wlCompanyLogo) {
      return wlCompanyLogo;
    } else {
      return CarrerClawLogo;
    }
  };

  // Default brand: the lion mark from the original SVG plus the name set in
  // the product's own typeface, so the header no longer mixes a serif
  // wordmark with a sans-serif UI. White-label customers and the
  // CustomResume domain keep their own full logo image, untouched.
  const isDefaultBrand = !isCustomResumeDomain() && !wlCompanyLogo;

  if (isDefaultBrand) {
    return (
      <span className="brand">
        <img
          src={CarrerClawMark}
          alt=""
          width={40}
          height={44}
          className="brand-mark"
          onError={onImageError}
        />
        <span className="brand-name">
          Career<span className="brand-name-accent">Claw</span>
        </span>
      </span>
    );
  }

  return (
    <>
      <img
        loading="lazy"
        src={getSrc()}
        alt="Logo"
        style={{ height: 48, width: isCustomResumeDomain() ? 170 : 150 }}
        onError={onImageError}
      />
    </>
  );
};

export default HeaderLogo;
